@if (definitions.length > 0) {
    <app-cascading-filter-bar [definitions]="definitions"
                              [initialSelection]="selection"
                              (selectionChange)="onSelectionChange($event)">
    </app-cascading-filter-bar>

    @if (resultCount !== null) {
        <span class="mathia-generic-search-filter__result-count">
            {{ resultCount }} {{ (resultCount < 2 ? 'generic.result' : 'generic.results') | translate }}
        </span>
    }
} @else {
    <span class="mathia-search-filter-loading">
        {{ 'generic.loading' | translate }}
    </span>
}
